import { createPortal } from 'react-dom';
import { Spinner } from './Spinner';

interface LoaderProps {
  isLoading: boolean;
}

export function Loader({ isLoading }: LoaderProps) {
  if (!isLoading) return null;

  return createPortal(
    <div className="bg-neutral-soft-surface/15 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
      <Spinner size={48} color="brand" strokeWidth={5} />
    </div>,
    document.body
  );
}
